import styled from 'styled-components';
import { ArtDecoButton } from '../theme/components/ArtDeco/ArtDecoButton';
import Stack from '@mui/material/Stack';

const MenuWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2)};
  text-align: center;
  text-align: center;
  border-top: 2px solid ${({ theme }) => theme.colors.primary};
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
`;

export const Menu = () => {
  return (
    <MenuWrapper>
        <nav>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <ArtDecoButton label="Home" width={120} />
            <ArtDecoButton label="Music" width={120} />
            <ArtDecoButton label="Video" width={120} />
            <ArtDecoButton label="About" width={120} />
          </Stack>
        </nav>
    </MenuWrapper>
  );
};